"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const ontario_design_system_component_library_react_1 = require("@ongov/ontario-design-system-component-library-react");
const header_menu_items_json_1 = __importDefault(require("./header-menu-items.json"));
const LocationHeader = ({ title, menuItems }) => {
    const { i18n } = (0, react_i18next_1.useTranslation)();
    const headerMenuItems = menuItems
        ? menuItems
        : header_menu_items_json_1.default[i18n.language].flatMap((item) => [
            {
                title: item.name,
                href: `https://ontario.ca/${item.link}`,
                linkIsActive: true,
                onClickHandler: () => { }
            },
        ]);
    return ((0, jsx_runtime_1.jsx)(ontario_design_system_component_library_react_1.OntarioHeader, { nonce: undefined, onResize: undefined, onResizeCapture: undefined, placeholder: undefined, onPointerEnterCapture: undefined, onPointerLeaveCapture: undefined, type: "ontario", languageToggleOptions: {
            englishLink: "/en",
            frenchLink: "/fr",
        }, menuItems: headerMenuItems }));
};
exports.default = LocationHeader;
